'use client'

import { useCallback, useRef } from 'react'

import { mapManager } from '../map-manager'

export const useLocationMarker = () => {
  const markerRef = useRef<naver.maps.Marker>(undefined)

  const updateLocationMarker = useCallback((latLng: naver.maps.LatLng) => {
    if (!latLng) return

    if (!markerRef.current) {
      mapManager.withMap(map => {
        markerRef.current = new naver.maps.Marker({
          position: latLng,
          map,
          icon: {
            content: `
            <div style="position: relative;">
              <div style="
                position: absolute;
                width: 30px;
                height: 30px;
                background: rgba(33, 150, 243, 0.2);
                border-radius: 50%;
                transform: translate(-50%, -50%);
              "></div>
              <div style="
                position: absolute;
                width: 20px;
                height: 20px;
                background: #2196F3;
                border: 2px solid white;
                border-radius: 50%;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
                transform: translate(-50%, -50%);
              "></div>
            </div>
          `,
            anchor: new naver.maps.Point(10, 10),
          },
        })
      })
    } else {
      markerRef.current.setPosition(latLng)
    }
  }, [])

  const removeLocationMarker = () => {
    if (markerRef.current) {
      markerRef.current.setMap(null)
      markerRef.current = undefined
    }
  }

  return {
    updateLocationMarker,
    removeLocationMarker,
  }
}
